"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentRowCardArrowEnd = exports.ContentRowCardArrow = exports.ContentRowCardArrowBegin = exports.ContentRowCardArrowWrapper = exports.ContentRowCard = exports.ContentRowCardStatus = exports.ContentRowArrowContainer = exports.ContentRowCardContainer = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1fjuvp3-0"
})(["display:flex;flex-direction:column;width:100%;height:4rem;justify-content:center;position:relative;"]);

exports.Wrapper = Wrapper;

var ContentRowCardContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCardContainer",
  componentId: "sc-1fjuvp3-1"
})(["position:absolute;width:", ";height:", ";left:", ";padding:0.2rem;display:flex;flex-direction:row;align-items:center;justify-content:flex-start;&:hover{z-index:", ";}"], function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '4rem';
}, function (_ref3) {
  var left = _ref3.left;
  return left || 0;
}, function (_ref4) {
  var zIndex = _ref4.zIndex;
  return zIndex || 'initial';
});

exports.ContentRowCardContainer = ContentRowCardContainer;
var ContentRowArrowContainer = (0, _styledComponents["default"])(ContentRowCardContainer).withConfig({
  displayName: "style__ContentRowArrowContainer",
  componentId: "sc-1fjuvp3-2"
})(["position:initial;height:initial;"]);
exports.ContentRowArrowContainer = ContentRowArrowContainer;

var ContentRowCardStatus = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCardStatus",
  componentId: "sc-1fjuvp3-3"
})(["background:", ";height:0.6rem;width:0.6rem;border-radius:0.6rem;"], function (_ref5) {
  var status = _ref5.status;
  return status ? _colors["default"].green.accent3 : _colors["default"].red;
});

exports.ContentRowCardStatus = ContentRowCardStatus;

var ContentRowCard = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCard",
  componentId: "sc-1fjuvp3-4"
})(["width:100%;height:100%;background:", ";border-radius:0.6rem;padding:0.6rem 0.2rem 0.6rem 0.8rem;display:flex;flex-direction:row;justify-content:flex- start;align-items:center;box-shadow:0 10px 20px rgba(0,0,0,0.19),0 6px 6px rgba(0,0,0,0.23);"], _colors["default"].blueGray.darken5);

exports.ContentRowCard = ContentRowCard;

var ContentRowCardArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCardArrowWrapper",
  componentId: "sc-1fjuvp3-5"
})(["position:absolute;left:", ";width:", ";height:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;"], function (_ref6) {
  var left = _ref6.left;
  return left || 0;
}, function (_ref7) {
  var width = _ref7.width;
  return width || '100%';
}, function (_ref8) {
  var height = _ref8.height;
  return height || '4rem';
});

exports.ContentRowCardArrowWrapper = ContentRowCardArrowWrapper;

var ContentRowCardArrowBegin = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCardArrowBegin",
  componentId: "sc-1fjuvp3-6"
})(["background:", ";width:2px;height:10px;"], _colors["default"].red);

exports.ContentRowCardArrowBegin = ContentRowCardArrowBegin;

var ContentRowCardArrow = _styledComponents["default"].hr.withConfig({
  displayName: "style__ContentRowCardArrow",
  componentId: "sc-1fjuvp3-7"
})(["border:1px ", " solid;border-style:dashed;width:98%;"], _colors["default"].red);

exports.ContentRowCardArrow = ContentRowCardArrow;

var ContentRowCardArrowEnd = _styledComponents["default"].div.withConfig({
  displayName: "style__ContentRowCardArrowEnd",
  componentId: "sc-1fjuvp3-8"
})(["position:absolute;right:0;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid ", ";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);font-size:0;line-height:0;"], _colors["default"].red);

exports.ContentRowCardArrowEnd = ContentRowCardArrowEnd;